/// <amd-module name="Repos/Views/CommitHub/Components/CommitPullRequestTable" />
import * as React from "react";
import { CommitPullRequest } from "Repos/Views/CommitHub/Contracts";
import * as Resources from "Repos/Views/CommitHub/Resources";
import { IReadonlyObservableArray, ObservableValue } from "VSS/Core/Observable";
import { ScreenBreakpoints } from "VSS/Core/Util/Screen";
import { VssComponent } from "VSS/Platform/Layout";
import { Ago } from "VSSUI/Ago";
import { ITableBreakpoint, ITableColumn, ITableRow, SimpleTableCell, Table } from "VSSUI/Table";
import { Tooltip } from "VSSUI/TooltipEx";
import { AgoFormat } from "VSSUI/Utilities/Date";
import { VssPersona } from "VSSUI/VssPersona";

const tableBreakpoints: ITableBreakpoint[] = [
    {
        breakpoint: ScreenBreakpoints.xsmall,
        columnWidths: [80, -250, 0, 0]
    },
    {
        breakpoint: ScreenBreakpoints.small,
        columnWidths: [80, 200, 180, -100]
    },
    {
        breakpoint: ScreenBreakpoints.medium,
        columnWidths: [80, 400, 270, -100]
    }
];

export interface ICommitPullRequestTableProps {
    items: IReadonlyObservableArray<CommitPullRequest>;
    onActivate: (event: React.SyntheticEvent<HTMLElement>, tableRow: ITableRow<CommitPullRequest>) => void;
}

export class CommitPullRequestTable extends VssComponent<ICommitPullRequestTableProps> {
    private columns = [idColumn, titleColumn, identityColumn, dateColumn];

    public render() {
        return (
            <Table<CommitPullRequest>
                className="repos-commit-pr-table"
                columns={this.columns}
                itemProvider={this.props.items}
                selectableText={true}
                onActivate={this.onActivate}
                tableBreakpoints={tableBreakpoints}
            />
        );
    }

    private onActivate = (event: React.SyntheticEvent<HTMLElement>, tableRow: ITableRow<CommitPullRequest>) => {
        this.props.onActivate(event, tableRow);
    };
}

const idColumn: ITableColumn<CommitPullRequest> = {
    id: "idColumn",
    renderCell: (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<CommitPullRequest>, tableItem: CommitPullRequest) => {
        return (
            <SimpleTableCell columnIndex={columnIndex} key={columnIndex} tableColumn={tableColumn}>
                {tableItem.pullRequestId}
            </SimpleTableCell>
        );
    },
    name: Resources.Id,
    width: new ObservableValue(80)
};

const titleColumn: ITableColumn<CommitPullRequest> = {
    id: "titleColumn",
    renderCell: (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<CommitPullRequest>, tableItem: CommitPullRequest) => {
        return (
            <SimpleTableCell columnIndex={columnIndex} key={columnIndex} tableColumn={tableColumn}>
                <Tooltip overflowOnly={true}>
                    <span className="text-ellipsis">{tableItem.title}</span>
                </Tooltip>
            </SimpleTableCell>
        );
    },
    name: Resources.Title,
    width: new ObservableValue(400)
};

const identityColumn: ITableColumn<CommitPullRequest> = {
    id: "createdByColumn",
    renderCell: (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<CommitPullRequest>, tableItem: CommitPullRequest) => {
        return (
            <SimpleTableCell columnIndex={columnIndex} key={columnIndex} tableColumn={tableColumn}>
                <>
                    <VssPersona
                        className="icon-margin"
                        displayName={tableItem.createdBy.displayName}
                        imageUrl={tableItem.createdBy.imageUrl}
                        size={"extra-small-plus"}
                    />
                    <Tooltip overflowOnly={true}>
                        <span className="text-ellipsis">{tableItem.createdBy.displayName}</span>
                    </Tooltip>
                </>
            </SimpleTableCell>
        );
    },
    name: Resources.CreatedBy,
    width: new ObservableValue(270)
};

const dateColumn: ITableColumn<CommitPullRequest> = {
    id: "dateColumn",
    renderCell: (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<CommitPullRequest>, tableItem: CommitPullRequest) => {
        return (
            <SimpleTableCell columnIndex={columnIndex} key={columnIndex} tableColumn={tableColumn}>
                <Ago date={tableItem.creationDate} format={AgoFormat.Compact} />
            </SimpleTableCell>
        );
    },
    name: Resources.CreatedDate,
    width: new ObservableValue(-120)
};
